import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ProfileAvatarComponent } from '../profile-avatar/profile-avatar.component';
import { DetailedCustomer } from '../../models/customer.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication';
import { firstValueFrom } from 'rxjs';
import { BRINGLIESEL_HELP_URL } from '../../../core/types/constants';
import { TestCustomerService } from '../../../core/services/test-customer/test-customer.service';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { ShopSelectionStore } from '../../../core/state/shop-selection.store';
import { SHOP_LISTING_QUERY_PARAMS_RESET } from '../../utils/shop-query-params';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatDividerModule,
    ProfileAvatarComponent,
  ],
})
export class MenuComponent {
  @Input() customer: DetailedCustomer;
  @Input() activePage: string;
  @Input() addTopMargin: boolean = false;
  @Output() menuOpenChange = new EventEmitter<boolean>();
  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private testCustomerService: TestCustomerService,
    private analyticsService: AnalyticsService,
    private shopSelectionStore: ShopSelectionStore
  ) {}

  get loggedUser() {
    return this.authenticationService.getLoggedUserFromStorage();
  }

  logOut(): void {
    this.menuOpenChange.emit(false);
    this.shopSelectionStore.clear();
    this.authenticationService.logout();
  }

  async redirectToCustomerSelection(): Promise<void> {
    const customer = await firstValueFrom(this.shopSelectionStore.customer$);
    this.menuOpenChange.emit(false);
    this.testCustomerService.clear();
    this.shopSelectionStore.clear();
    let queryParams = {};
    if (customer) {
      queryParams = { preSelectCustomerId: customer.id };
    }
    this.router.navigate(['/customer-select'], { queryParams });
  }

  goToPage(page: string): void {
    this.menuOpenChange.emit(false);
    const params = this.route.snapshot.queryParams;
    this.router.navigate([page], {
      queryParams: { customerId: params.customerId, departmentId: null },
    });
  }
  goToProfilePage(): void {
    this.menuOpenChange.emit(false);
    this.router.navigate([`/user-profile/${this.loggedUser.id}`], {
      queryParams: SHOP_LISTING_QUERY_PARAMS_RESET,
      queryParamsHandling: 'merge',
    });
  }

  redirectToHelpPage(): void {
    this.analyticsService.trackEvent('select_content', {
      content_type: 'help_menu',
    });
    window.open(BRINGLIESEL_HELP_URL, '_blank');
  }
}
